/* FNDRY — announcement bar
   Rotates the message blocks. Pauses on hover, on focus, while the
   tab is hidden, and while a block is selected in the editor.
   Auto-rotation is off entirely under prefers-reduced-motion —
   auto-advancing text is the thing that rule exists for. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function FndryAnnouncement(root) {
    this.root = root;
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-announcement-item]'));
    this.index = 0;
    this.timer = null;
    this.paused = false;
    this.pinned = false; /* editor block selection wins over everything */
    this.interval = parseInt(root.dataset.interval, 10) || 5000;

    if (this.items.length < 2) return;

    var self = this;
    root.addEventListener('mouseenter', function () { self.pause(); });
    root.addEventListener('mouseleave', function () { self.resume(); });
    root.addEventListener('focusin', function () { self.pause(); });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) self.resume();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.pause();
      else self.resume();
    });

    /* P15 sitewide 2026-10-23: no rotation while the bar has scrolled out of
       sight - each crossfade restyled the page mid-scroll for a message
       nobody could see. It carries on from the same message when it is back. */
    this.away = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var away = !entries[entries.length - 1].isIntersecting;
        if (away === self.away) return;
        self.away = away;
        if (away) self.stop();
        else self.start();
      }).observe(root);
    }

    this.start();
  }

  FndryAnnouncement.prototype.show = function (i) {
    var n = this.items.length;
    this.index = ((i % n) + n) % n;
    var active = this.index;
    this.items.forEach(function (item, j) {
      var on = j === active;
      item.classList.toggle('is-active', on);
      /* inert, not CSS visibility — see the note in fndry-announcement.css.
         It takes the queued message out of the tab order and the a11y tree
         in the same tick, whatever the crossfade is doing. */
      if (on) { item.removeAttribute('inert'); item.removeAttribute('aria-hidden'); }
      else { item.setAttribute('inert', ''); item.setAttribute('aria-hidden', 'true'); }
    });
  };

  FndryAnnouncement.prototype.start = function () {
    this.stop();
    if (REDUCED.matches || this.paused || this.pinned || this.away || this.items.length < 2) return;
    var self = this;
    this.timer = window.setInterval(function () { self.show(self.index + 1); }, this.interval);
  };

  FndryAnnouncement.prototype.stop = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  FndryAnnouncement.prototype.pause = function () { this.paused = true; this.stop(); };
  FndryAnnouncement.prototype.resume = function () { this.paused = false; this.start(); };

  /* ---------- Boot ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-fndry-announcement]').forEach(function (root) {
      if (root.dataset.fndryAnnouncementReady === 'true') return;
      root.dataset.fndryAnnouncementReady = 'true';
      root.__fndryAnnouncement = new FndryAnnouncement(root);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Editor: hold the selected message on screen while it is being edited. */
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-fndry-announcement]');
    var api = root && root.__fndryAnnouncement;
    if (!api) return;
    api.pinned = true;
    api.stop();
    api.show(api.items.indexOf(e.target));
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-fndry-announcement]');
    var api = root && root.__fndryAnnouncement;
    if (!api) return;
    api.pinned = false;
    api.start();
  });
})();
